import React from "react";

function MissionVision() {
  return (
    <div className="relative bg-primary-light -z-20">
      {/* Title Page */}
      {/* svg for mmobile screen size */}

      <div className="absolute top-0 md:hidden">
        <svg
          className="w-full h-[232px] fill-none"
          viewBox="0 0 375 232"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g filter="url(#filter0_d_412_2589)">
            <path
              d="M138.231 128.642L194.538 94.5355L254.091 61.7961L283.853 44.9645L313.615 30.0565L375 0C375 0 327.014 34.8143 308.649 70.8899C290.284 106.966 301.836 180.883 301.836 180.883C301.836 180.883 147.512 164.485 111.078 171.549C74.6446 178.612 0 223.265 0 223.265L66.2166 174.328L100.762 151.004L138.231 128.642Z"
              fill="#F8EDF2"
            />
            <path
              d="M138.359 128.856L138.36 128.856L194.659 94.7546L194.668 94.7493L254.211 62.0152L254.214 62.0137L283.965 45.188L283.976 45.1821L313.725 30.281L313.727 30.28L372.706 1.40183C371.358 2.42453 369.427 3.91443 367.059 5.80817C362.27 9.63851 355.693 15.1216 348.542 21.733C334.244 34.9511 317.63 52.698 308.427 70.7765C299.213 88.8756 297.514 116.431 298.106 139.421C298.403 150.924 299.273 161.298 300.07 168.796C300.468 172.545 300.848 175.576 301.128 177.669C301.268 178.716 301.384 179.529 301.464 180.08C301.495 180.293 301.521 180.467 301.541 180.6L301.419 180.587C301.288 180.574 301.129 180.557 300.942 180.537C300.711 180.513 300.436 180.484 300.12 180.452C298.981 180.333 297.305 180.161 295.159 179.943C290.868 179.509 284.697 178.896 277.178 178.182C262.139 176.755 241.708 174.926 220.139 173.317C198.569 171.709 175.859 170.321 156.262 169.777C136.674 169.233 120.17 169.531 111.031 171.303C92.7729 174.843 64.9725 187.79 41.7613 199.834C30.1501 205.859 19.6782 211.663 12.109 215.961C8.79547 217.842 6.0381 219.435 3.98489 220.631L66.3565 174.535L66.3652 174.529L100.896 151.215L138.359 128.856Z"
              stroke="#CBCACA"
              strokeWidth="0.5"
            />
          </g>
          <defs>
            <filter
              id="filter0_d_412_2589"
              x="-4"
              y="0"
              width="383"
              height="231.266"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset dy="4" />
              <feGaussianBlur stdDeviation="2" />
              <feComposite in2="hardAlpha" operator="out" />
              <feColorMatrix
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
              />
              <feBlend
                mode="normal"
                in2="BackgroundImageFix"
                result="effect1_dropShadow_412_2589"
              />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="effect1_dropShadow_412_2589"
                result="shape"
              />
            </filter>
          </defs>
        </svg>
        {/* shadow */}
      </div>
      <div className="absolute top-2 -z-10 md:hidden">
        <svg
          className="w-full h-[232px] fill-none"
          viewBox="0 0 372 236"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g filter="url(#filter0_d_412_2587)">
            <path
              d="M0.71759 0.59375H362.329C362.329 0.59375 316.056 35.4041 298.347 71.4758C280.638 107.547 291.778 181.456 291.778 181.456C291.778 181.456 142.963 165.06 107.83 172.123C72.6971 179.186 0.71759 217 0.71759 217V0.59375Z"
              fill="#E8EBE9"
            />
          </g>
          <defs>
            <filter
              id="filter0_d_412_2587"
              x="0.71759"
              y="0.59375"
              width="370.611"
              height="235.406"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset dx="5" dy="15" />
              <feGaussianBlur stdDeviation="2" />
              <feComposite in2="hardAlpha" operator="out" />
              <feColorMatrix
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
              />
              <feBlend
                mode="normal"
                in2="BackgroundImageFix"
                result="effect1_dropShadow_412_2587"
              />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="effect1_dropShadow_412_2587"
                result="shape"
              />
            </filter>
          </defs>
        </svg>
      </div>
      <div className="absolute top-0 md:hidden -z-10">
        <svg
          // width="375"
          // height="230"
          className="w-full h-[232px]"
          viewBox="0 0 375 230"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g filter="url(#filter0_d_412_2588)">
            <path
              d="M0 2.00001C0 0.895438 0.895431 0 2 0H368.838C370.776 0 371.64 2.52247 370.112 3.71479C357.43 13.6106 323.437 41.8413 308.649 70.8899C292.304 102.999 299.658 165.085 301.473 178.35C301.651 179.652 300.648 180.757 299.341 180.622C279.321 178.552 144.776 165.015 111.078 171.549C79.0037 177.767 17.3148 213.118 3.01233 221.489C1.67164 222.273 0 221.292 0 219.738V2.00001Z"
              fill="#FCF4F7"
            />
            <path
              d="M0.25 2.00001C0.25 1.03351 1.0335 0.25 2 0.25H368.838C370.537 0.25 371.299 2.47099 369.958 3.5177C363.612 8.4693 351.935 18.0078 339.993 29.9432C328.054 41.876 315.838 56.2177 308.427 70.7765C300.225 86.8877 297.979 110.489 298.001 131.687C298.023 152.896 300.317 171.746 301.225 178.384C301.383 179.537 300.501 180.491 299.366 180.374C289.356 179.338 250.711 175.436 210.356 172.61C190.179 171.196 169.571 170.052 151.901 169.669C134.238 169.286 119.485 169.664 111.031 171.303C94.9552 174.42 71.4858 184.828 50.2685 195.488C29.0424 206.153 10.0394 217.086 2.88606 221.273C1.71624 221.957 0.25 221.104 0.25 219.738V2.00001Z"
              stroke="#CBCACA"
              strokeWidth="0.5"
            />
          </g>
          <defs>
            <filter
              id="filter0_d_412_2588"
              x="-4"
              y="0"
              width="378.893"
              height="229.765"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset dy="4" />
              <feGaussianBlur stdDeviation="2" />
              <feComposite in2="hardAlpha" operator="out" />
              <feColorMatrix
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
              />
              <feBlend
                mode="normal"
                in2="BackgroundImageFix"
                result="effect1_dropShadow_412_2588"
              />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="effect1_dropShadow_412_2588"
                result="shape"
              />
            </filter>
          </defs>
        </svg>
      </div>

      {/* svg for desktop */}

      <div className="absolute laptop:-top-8 laptopLg:top-0 laptopSm:-top-20 laptopSm:block  hidden">
        <svg
          className="laptop:w-[90%] laptopSm:w-[75%] laptopLg:w-full w-1/3 h-[597px] fill-none"
          // width="772"
          // height="597"
          viewBox="0 0 772 597"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g filter="url(#filter0_d_232_690)">
            <path
              d="M282.167 338.833L397.705 249L519.903 162.767L580.973 118.433L642.043 79.1667L768 0C768 0 669.537 91.6984 631.853 186.719C594.17 281.74 617.874 476.433 617.874 476.433C617.874 476.433 301.211 433.242 226.452 451.847C151.693 470.452 -1.47247 588.066 -1.47247 588.066L134.399 459.167L205.284 397.733L282.167 338.833Z"
              fill="#F8EDF2"
            />
            <path
              d="M282.319 339.032L282.32 339.031L397.85 249.204L397.859 249.197L520.047 162.971L520.05 162.969L581.108 118.644L581.12 118.636L642.176 79.3783L642.178 79.3769L765.999 1.55264C765.339 2.18512 764.508 2.98573 763.521 3.94663C760.754 6.64099 756.759 10.5957 751.847 15.6381C742.024 25.7229 728.534 40.1591 713.867 57.5657C684.534 92.375 650.477 139.079 631.621 186.627C612.759 234.189 609.267 306.663 610.482 367.214C611.09 397.496 612.876 424.807 614.51 444.548C615.327 454.418 616.106 462.397 616.68 467.907C616.968 470.663 617.204 472.801 617.368 474.251C617.408 474.599 617.443 474.907 617.474 475.174C617.508 475.464 617.536 475.707 617.559 475.901C617.569 475.992 617.579 476.072 617.587 476.142L616.997 476.062C616.694 476.021 616.317 475.97 615.868 475.91C615.426 475.85 614.913 475.782 614.332 475.704C611.995 475.393 608.556 474.938 604.153 474.365C595.348 473.221 582.686 471.606 567.257 469.727C536.401 465.968 494.479 461.15 450.221 456.914C405.964 452.678 359.367 449.023 319.159 447.589C278.964 446.157 245.12 446.943 226.391 451.604C207.669 456.264 184.056 467.116 159.179 480.761C134.299 494.408 108.138 510.859 84.3164 526.725C60.4946 542.592 39.0097 557.877 23.4804 569.196C15.7157 574.855 9.43974 579.523 5.1048 582.776C3.92901 583.658 2.89602 584.436 2.01485 585.102L134.563 459.356L134.571 459.348L205.436 397.932L205.448 397.922L282.319 339.032Z"
              stroke="#CBCACA"
              strokeWidth="0.5"
            />
          </g>
          <defs>
            <filter
              id="filter0_d_232_690"
              x="-5.47247"
              y="0"
              width="777.472"
              height="596.066"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset dy="4" />
              <feGaussianBlur stdDeviation="2" />
              <feComposite in2="hardAlpha" operator="out" />
              <feColorMatrix
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
              />
              <feBlend
                mode="normal"
                in2="BackgroundImageFix"
                result="effect1_dropShadow_232_690"
              />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="effect1_dropShadow_232_690"
                result="shape"
              />
            </filter>
          </defs>
        </svg>
      </div>
      {/* shadow for desktop */}
      <div className="absolute laptop:-top-7 laptopLg:top-2 laptopSm:-top-[70px] laptopSm:block  hidden -z-10">
        <svg
          className="laptop:w-[90%] laptopSm:w-[75%] laptopLg:w-full w-1/3 h-[597px] fill-none"
          // width="751"
          // height="589"
          viewBox="0 0 751 589"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g filter="url(#filter0_d_232_684)">
            <path
              d="M0 0H742C742 0 647.052 91.6881 610.714 186.698C574.376 281.708 597.234 476.38 597.234 476.38C597.234 476.38 291.877 433.193 219.787 451.797C147.697 470.4 0 570 0 570V0Z"
              fill="#E8EBE9"
            />
          </g>
          <defs>
            <filter
              id="filter0_d_232_684"
              x="0"
              y="0"
              width="751"
              height="589"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset dx="5" dy="15" />
              <feGaussianBlur stdDeviation="2" />
              <feComposite in2="hardAlpha" operator="out" />
              <feColorMatrix
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
              />
              <feBlend
                mode="normal"
                in2="BackgroundImageFix"
                result="effect1_dropShadow_232_684"
              />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="effect1_dropShadow_232_684"
                result="shape"
              />
            </filter>
          </defs>
        </svg>
      </div>
      <div className="absolute laptop:-top-8 laptopLg:top-0 laptopSm:-top-20 laptopSm:block  hidden -z-10">
        <svg
          className="laptop:w-[90%] laptopSm:w-[75%] laptopLg:w-full w-1/3 h-[597px] fill-none"
          // width="771"
          // height="595"
          viewBox="0 0 771 595"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g filter="url(#filter0_d_232_681)">
            <path
              d="M0 2C0 0.895431 0.89543 0 2 0H764.39C766.207 0 767.158 2.19498 765.854 3.45933C747.766 20.9974 666.704 102.555 633.326 186.719C598.158 275.396 616.455 450.88 619.055 473.917C619.202 475.219 618.275 476.287 616.976 476.113C587.852 472.211 298.892 434.185 227.924 451.847C159.49 468.878 25.3552 568.873 3.14867 585.671C1.82591 586.672 0 585.667 0 584.008V2Z"
              fill="#FCF4F7"
            />
            <path
              d="M0.25 2C0.25 1.0335 1.0335 0.25 2 0.25H764.39C765.999 0.25 766.811 2.18332 765.68 3.27985C747.593 20.8169 666.493 102.407 633.093 186.627C615.49 231.015 611.274 297.098 611.777 354.935C612.281 412.782 617.506 462.422 618.806 473.945C618.872 474.53 618.696 475.049 618.374 475.399C618.054 475.747 617.579 475.942 617.009 475.865C602.446 473.914 522.921 463.432 438.164 455.645C395.786 451.751 352.097 448.531 314.565 447.389C277.044 446.247 245.644 447.179 227.864 451.604C193.6 460.132 142.924 489.413 98.0646 518.637C53.1937 547.869 14.1031 577.071 2.99785 585.472C1.85796 586.334 0.25 585.483 0.25 584.008V2Z"
              stroke="#CBCACA"
              strokeWidth="0.5"
            />
          </g>
          <defs>
            <filter
              id="filter0_d_232_681"
              x="-4"
              y="0"
              width="774.458"
              height="594.07"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset dy="4" />
              <feGaussianBlur stdDeviation="2" />
              <feComposite in2="hardAlpha" operator="out" />
              <feColorMatrix
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
              />
              <feBlend
                mode="normal"
                in2="BackgroundImageFix"
                result="effect1_dropShadow_232_681"
              />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="effect1_dropShadow_232_681"
                result="shape"
              />
            </filter>
          </defs>
        </svg>
      </div>
      {/* content for desktop */}
      <div className="hidden laptopSm:flex laptopSm:flex-row responsive-padding   mb-8">
        <div className="w-1/2">
          <div className="h-[520px] font-bold font-montserrat text-lg md:text-3xl laptop:text-4xl  text-text-dark align-middle z-50 pt-10">
            <h1 className=" leading-none pr-60 laptop:pr-72 pt-10 ">
              {" "}
              Mission, Vision, Goals & objectives
            </h1>
          </div>
          {/* Objective */}
          <div className=" font-montserrat font-bold leading-6 tracking-[0.06em] px-6 py-4">
            <div>
              <span className="text-secondary-normal text-base laptopSm:text-2xl">
                03
              </span>
              <h6 className="uppercase text-black text-xl md:text-lg laptopSm:text-[28px]">
                OBJECTIVE
              </h6>
            </div>
            <div className="font-notoSans font-light text-xs  md:text-sm mt-6 align-top leading-6  tracking-[0.06em]">
              <p>
                Specifically, Jamiatu Marawi Al-islamia Foundation (JMIF) aims
                to:
              </p>{" "}
              <br />
              <ol className="  list-decimal  pl-4 ">
                <li>
                  Integrate Islamic precepts in all subject areas, especially in
                  science and technology.
                </li>
                <li>
                  Provide activities for the optimum and integral development of
                  the learners spiritually, physically, intellectually, socially
                  and emotionally
                </li>
                <li>
                  Promote the Internalization of Mamic values, social
                  responsibilities and leadership for peace and development.
                </li>
                <li>
                  Provide technological and economic skills for gainful living
                  and sustainable development, and strengthen linkages with
                  local, national and international agencies for the
                  implementation of its goals and objectives.
                </li>
              </ol>
            </div>
          </div>
        </div>
        <div className="laptopSm:w-1/2 flex flex-col gap-5 py-10 pl-5">
          {/* vision */}
          <div className=" font-montserrat font-bold leading-6 tracking-[0.06em] px-6 py-4 laptopSm:block hidden">
            <div>
              <span className="text-secondary-normal text-base laptopSm:text-2xl ">
                01
              </span>
              <h6 className="uppercase text-black text-xl md:text-lg laptopSm:text-[28px]">
                VISION
              </h6>
            </div>
            <p className=" font-notoSans font-light text-xs md:text-sm mt-6 leading-6 tracking-[0.06em] ">
              The Jamiatu Marawi Al-Islamia Foundation (JMIF) is for the new
              generation of Muslims who are prepared to actualize each role as
              vicegerent of Allah on earth and to contribute fully  to the
              development of their family, society, and global community.
            </p>
          </div>
          {/* Mission */}
          <div className=" font-montserrat font-bold leading-6 tracking-[0.06em] px-6 py-4 laptopSm:block hidden">
            <div>
              <span className="text-secondary-normal text-base laptopSm:text-2xl">
                02
              </span>
              <h6 className="uppercase text-black text-xl  md:text-lg laptopSm:text-[28px]">
                MISSION
              </h6>
            </div>
            <ol className=" font-notoSans font-light text-xs md:text-sm mt-6 list-decimal align-top pl-4 leading-6 tracking-[0.06em]">
              <li>To relevantize and Islamize the curricula for all levels.</li>
              <li>
                To produce Muslims and model professionals dedicated to the
                cause of Islam.
              </li>
              <li>
                To Instill pride in leading the preservation of the Muslim
                Cultural Heritage
              </li>
              <li>
                To promote awareness and empowerment among its learners and
                constituents in contributing to the solutions of local, national
                and global problems through academic, research and extension,
                and
              </li>
              <li>
                {" "}
                To foster peace and development through inter cultural
                solidarity and Islamic percepts.
              </li>
            </ol>
          </div>
          {/* Goals */}
          <div className=" font-montserrat font-bold leading-6 tracking-[0.06em] px-6 py-4">
            <div>
              <span className="text-secondary-normal text-base laptopSm:text-2xl">
                04
              </span>
              <h6 className="uppercase text-black text-xl md:text-lg laptopSm:text-[28px]">
                Goal
              </h6>
            </div>
            <div className="font-notoSans font-light text-xs  md:text-sm mt-6 align-top leading-6  tracking-[0.06em]">
              <p>
                The Jamiatu Marawi Al-Islamia Foundation (JMIF) strives to:{" "}
              </p>{" "}
              <br />
              <ol className="  list-decimal  pl-4 ">
                <li>
                  Enhance the potentials of individuals for a balanced,
                  harmonious, peaceful and development-oriented Muslims based on
                  islamic values
                </li>
                <li>
                  Effect a globally quality education at all levels both in
                  Blame Studies and Arabic language and in English learning.
                </li>
              </ol>
            </div>
          </div>
        </div>
      </div>

      {/* svg for tablet screen size */}
      {/* Stroke */}
      <div className="absolute top-0 hidden  laptopSm:hidden">
        <svg
          className="w-full h-[335px] fill-none"
          // width="550"
          // height="335"
          viewBox="0 0 550 335"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g filter="url(#filter0_d_669_3557)">
            <path
              d="M201.751 188.522L283.526 138.609L370.015 90.6966L413.238 66.0642L456.462 44.247L545.61 0.260742C545.61 0.260742 475.921 51.2099 449.249 104.005C422.578 156.8 439.355 264.975 439.355 264.975C439.355 264.975 215.231 240.977 162.318 251.314C109.406 261.652 1 327 1 327L97.166 255.381L147.336 221.248L201.751 188.522Z"
              fill="#F8EDF2"
            />
            <path
              d="M201.88 188.736L201.882 188.735L283.648 138.828L283.657 138.823L370.136 90.9153L370.138 90.9138L413.351 66.2874L413.362 66.2814L456.572 44.4712L456.574 44.4702L543.296 1.68154C543.024 1.88715 542.73 2.11159 542.412 2.35445C540.453 3.85188 537.624 6.04963 534.148 8.85181C527.194 14.4561 517.645 22.4785 507.261 32.1518C486.499 51.4936 462.382 77.4541 449.026 103.892C435.66 130.351 433.19 170.65 434.051 204.294C434.481 221.124 435.745 236.303 436.902 247.274C437.48 252.759 438.032 257.193 438.439 260.256C438.642 261.788 438.809 262.977 438.926 263.783C438.983 264.18 439.029 264.485 439.06 264.692L438.737 264.657C438.311 264.612 437.679 264.546 436.851 264.459C435.197 264.286 432.763 264.033 429.647 263.715C423.415 263.079 414.453 262.182 403.533 261.138C381.693 259.049 352.022 256.372 320.698 254.019C289.373 251.665 256.393 249.634 227.935 248.838C199.486 248.042 175.53 248.478 162.27 251.069C135.773 256.246 95.4124 275.185 61.7011 292.812C44.8398 301.628 29.6327 310.121 18.641 316.41C13.1451 319.555 8.70288 322.149 5.63452 323.956C5.42096 324.082 5.21407 324.204 5.01393 324.322L97.3066 255.588L97.3153 255.582L147.471 221.458L201.88 188.736Z"
              stroke="#CBCACA"
              strokeWidth="0.5"
            />
          </g>
          <defs>
            <filter
              id="filter0_d_669_3557"
              x="-3"
              y="0.260742"
              width="552.61"
              height="334.739"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset dy="4" />
              <feGaussianBlur stdDeviation="2" />
              <feComposite in2="hardAlpha" operator="out" />
              <feColorMatrix
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
              />
              <feBlend
                mode="normal"
                in2="BackgroundImageFix"
                result="effect1_dropShadow_669_3557"
              />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="effect1_dropShadow_669_3557"
                result="shape"
              />
            </filter>
          </defs>
        </svg>
      </div>
      {/* tablet svg shadow */}
      <div className="absolute top-0 -z-10 hidden  laptopSm:hidden">
        <svg
          width="563"
          height="348"
          viewBox="0 0 563 348"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g filter="url(#filter0_d_669_3555)">
            <path
              d="M0 0H554C554 0 483.109 52.9217 455.978 107.761C428.847 162.6 445.913 274.963 445.913 274.963C445.913 274.963 217.924 250.036 164.1 260.774C110.275 271.512 0 329 0 329V0Z"
              fill="#F7F7F7"
            />
          </g>
          <defs>
            <filter
              id="filter0_d_669_3555"
              x="0"
              y="0"
              width="563"
              height="348"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset dx="5" dy="15" />
              <feGaussianBlur stdDeviation="2" />
              <feComposite in2="hardAlpha" operator="out" />
              <feColorMatrix
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
              />
              <feBlend
                mode="normal"
                in2="BackgroundImageFix"
                result="effect1_dropShadow_669_3555"
              />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="effect1_dropShadow_669_3555"
                result="shape"
              />
            </filter>
          </defs>
        </svg>
      </div>
      {/* flip white bg */}
      <div className="absolute top-0 -z-10 hidden md:block laptopSm:hidden">
        <svg
          width="549"
          height="348"
          viewBox="0 0 549 348"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g filter="url(#filter0_d_669_3554)">
            <path
              d="M0 0H536C536 0 467.412 52.9217 441.163 107.761C414.913 162.6 431.425 274.963 431.425 274.963C431.425 274.963 210.844 250.036 158.768 260.774C106.692 271.512 0 329 0 329V0Z"
              fill="#F7F7F7"
            />
          </g>
          <g filter="url(#filter1_d_669_3554)">
            <path
              d="M200.751 190.522L282.526 140.609L369.015 92.6966L412.238 68.0642L455.462 46.247L544.61 2.26074C544.61 2.26074 474.921 53.2099 448.249 106.005C421.578 158.8 438.355 266.975 438.355 266.975C438.355 266.975 214.231 242.977 161.318 253.314C108.406 263.652 0 329 0 329L96.166 257.381L146.336 223.248L200.751 190.522Z"
              fill="#F8EDF2"
            />
            <path
              d="M200.88 190.736L200.882 190.735L282.648 140.828L282.657 140.823L369.136 92.9153L369.138 92.9138L412.351 68.2874L412.362 68.2814L455.572 46.4712L455.574 46.4702L542.296 3.68154C542.024 3.88715 541.73 4.11159 541.412 4.35445C539.453 5.85188 536.624 8.04963 533.148 10.8518C526.194 16.4561 516.645 24.4785 506.261 34.1518C485.499 53.4936 461.382 79.4541 448.026 105.892C434.66 132.351 432.19 172.65 433.051 206.294C433.481 223.124 434.745 238.303 435.902 249.274C436.48 254.759 437.032 259.193 437.439 262.256C437.642 263.788 437.809 264.977 437.926 265.783C437.983 266.18 438.029 266.485 438.06 266.692L437.737 266.657C437.311 266.612 436.679 266.546 435.851 266.459C434.197 266.286 431.763 266.033 428.647 265.715C422.415 265.079 413.453 264.182 402.533 263.138C380.693 261.049 351.022 258.372 319.698 256.019C288.373 253.665 255.393 251.634 226.935 250.838C198.486 250.042 174.53 250.478 161.27 253.069C134.773 258.246 94.4124 277.185 60.7011 294.812C43.8398 303.628 28.6327 312.121 17.641 318.41C12.1451 321.555 7.70288 324.149 4.63452 325.956C4.42096 326.082 4.21407 326.204 4.01393 326.322L96.3066 257.588L96.3153 257.582L146.471 223.458L200.88 190.736Z"
              stroke="#CBCACA"
              strokeWidth="0.5"
            />
          </g>
          <defs>
            <filter
              id="filter0_d_669_3554"
              x="0"
              y="0"
              width="545"
              height="348"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset dx="5" dy="15" />
              <feGaussianBlur stdDeviation="2" />
              <feComposite in2="hardAlpha" operator="out" />
              <feColorMatrix
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
              />
              <feBlend
                mode="normal"
                in2="BackgroundImageFix"
                result="effect1_dropShadow_669_3554"
              />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="effect1_dropShadow_669_3554"
                result="shape"
              />
            </filter>
            <filter
              id="filter1_d_669_3554"
              x="-4"
              y="2.26074"
              width="552.61"
              height="334.739"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset dy="4" />
              <feGaussianBlur stdDeviation="2" />
              <feComposite in2="hardAlpha" operator="out" />
              <feColorMatrix
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
              />
              <feBlend
                mode="normal"
                in2="BackgroundImageFix"
                result="effect1_dropShadow_669_3554"
              />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="effect1_dropShadow_669_3554"
                result="shape"
              />
            </filter>
          </defs>
        </svg>
      </div>
      <div className="bg-[#FCF4F7] pt-5 mobileSm:hidden"></div>
      {/* Mobile */}
      <div className="h-[210px] md:h-[329px]  responsive-padding font-bold font-montserrat text-lg md:text-2xl  text-text-dark align-middle z-50 mobileSm:pt-10 md:pt-16 laptopSm:hidden">
        <h1 className="">
          Mission, Vision, Goals <br /> & objectives
        </h1>
      </div>
      {/* content */}
      <div className="responsive-padding mb-14 laptopSm:hidden">
        {/* vision */}
        <div className=" font-montserrat font-bold leading-6 tracking-[0.06em] px-6 py-4 laptopSm:hidden">
          <div>
            <span className="text-secondary-normal text-base ">01</span>
            <h6 className="uppercase text-black text-xl">VISION</h6>
          </div>
          <p className=" font-notoSans font-light text-xs mt-6 leading-6 tracking-[0.06em]">
            The Jamiatu Marawi Al-Islamia Foundation (JMIF) is for the new
            generation of Muslims who are prepared to actualize each role as
            vicegerent of Allah on earth and to contribute fully  to the
            development of their family, society, and global community.
          </p>
        </div>
        {/* Mission */}
        <div className=" font-montserrat font-bold leading-6 tracking-[0.06em] px-6 py-4 laptopSm:hidden">
          <div>
            <span className="text-secondary-normal text-base ">02</span>
            <h6 className="uppercase text-black text-xl">MISSION</h6>
          </div>
          <ol className=" font-notoSans font-light text-xs mt-6 list-decimal align-top pl-4 leading-6 tracking-[0.06em]">
            <li>To relevantize and Islamize the curricula for all levels.</li>
            <li>
              To produce Muslims and model professionals dedicated to the cause
              of Islam.
            </li>
            <li>
              To Instill pride in leading the preservation of the Muslim
              Cultural Heritage
            </li>
            <li>
              To promote awareness and empowerment among its learners and
              constituents in contributing to the solutions of local, national
              and global problems through academic, research and extension, and
            </li>
            <li>
              {" "}
              To foster peace and development through inter cultural solidarity
              and Islamic percepts.
            </li>
          </ol>
        </div>

        {/* Objective */}
        <div className=" font-montserrat font-bold leading-6 tracking-[0.06em] px-6 py-4">
          <div>
            <span className="text-secondary-normal text-base laptopSm:text-2xl">
              03
            </span>
            <h6 className="uppercase text-black text-xl md:text-lg laptopSm:text-[28px]">
              OBJECTIVE
            </h6>
          </div>
          <div className="font-notoSans font-light text-xs  md:text-sm mt-6 align-top leading-6  tracking-[0.06em]">
            <p>
              Specifically, Jamiatu Marawi Al-islamia Foundation (JMIF) aims to:
            </p>{" "}
            <br />
            <ol className="  list-decimal  pl-4 ">
              <li>
                Integrate Islamic precepts in all subject areas, especially in
                science and technology.
              </li>
              <li>
                Provide activities for the optimum and integral development of
                the learners spiritually, physically, intellectually, socially
                and emotionally
              </li>
              <li>
                Promote the Internalization of Mamic values, social
                responsibilities and leadership for peace and development.
              </li>
              <li>
                Provide technological and economic skills for gainful living and
                sustainable development, and strengthen linkages with local,
                national and international agencies for the implementation of
                its goals and objectives.
              </li>
            </ol>
          </div>
        </div>
        {/* Goals */}
        <div className=" font-montserrat font-bold leading-6 tracking-[0.06em] px-6 py-4 laptopSm:hidden">
          <div>
            <span className="text-secondary-normal text-base laptopSm:text-2xl">
              04
            </span>
            <h6 className="uppercase text-black text-xl md:text-lg laptopSm:text-[28px]">
              Goal
            </h6>
          </div>
          <div className="font-notoSans font-light text-xs  md:text-sm mt-6 align-top leading-6  tracking-[0.06em]">
            <p>The Jamiatu Marawi Al-Islamia Foundation (JMIF) strives to: </p>{" "}
            <br />
            <ol className="  list-decimal  pl-4 ">
              <li>
                Enhance the potentials of individuals for a balanced,
                harmonious, peaceful and development-oriented Muslims based on
                islamic values
              </li>
              <li>
                Effect a globally quality education at all levels both in Blame
                Studies and Arabic language and in English learning.
              </li>
            </ol>
          </div>
        </div>
      </div>
    </div>
  );
}

export default MissionVision;
